import { render } from "./ConfigLabel.vue?vue&type=template&id=0e2cd2aa"
import script from "./ConfigLabel.vue?vue&type=script&lang=js"
export * from "./ConfigLabel.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__